<div style="display: flex; justify-content: space-between">
  <div
    id="message"
    style="
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
      margin: auto;
      font-size: 1.5em;
    "
  >
    {{ data.message }}
  </div>
  @if (type == 'info') {
    <div
      id="info-icon"
      style="
        display: flex;
        justify-content: center;
        align-items: center;
        height: 50px;
        width: 50px;
      "
    >
      <app-icon
        [type]="'Info'"
        [color]="'#ffffff'"
        (click)="snackBarRef.dismissWithAction()"
        (keydown.enter)="snackBarRef.dismissWithAction()"
        style="cursor: pointer; height: 100%; width: 100%"
      />
    </div>
  }
  @if (type == 'error') {
    <div
      id="error-icon"
      style="
        display: flex;
        justify-content: center;
        align-items: center;
        height: 50px;
        width: 50px;
      "
    >
      <app-icon
        [type]="'Error'"
        [color]="'#ffffff'"
        (click)="snackBarRef.dismissWithAction()"
        (keydown.enter)="snackBarRef.dismissWithAction()"
        style="cursor: pointer; height: 100%; width: 100%"
      />
    </div>
  }
  @if (type == 'warning') {
    <div
      id="warning-icon"
      style="
        display: flex;
        justify-content: center;
        align-items: center;
        height: 50px;
        width: 50px;
      "
    >
      <app-icon
        [type]="'Warning'"
        [color]="'#ffffff'"
        (click)="snackBarRef.dismissWithAction()"
        (keydown.enter)="snackBarRef.dismissWithAction()"
        style="cursor: pointer; height: 100%; width: 100%"
      />
    </div>
  }
  @if (type == 'success') {
    <div
      id="success-icon"
      style="
        display: flex;
        justify-content: center;
        align-items: center;
        height: 50px;
        width: 50px;
      "
    >
      <app-icon
        [type]="'Success'"
        [color]="'#ffffff'"
        (click)="snackBarRef.dismissWithAction()"
        (keydown.enter)="snackBarRef.dismissWithAction()"
        style="cursor: pointer; height: 100%; width: 100%"
      />
    </div>
  }
</div>
